import { useQuery } from "@tanstack/react-query";
import { useTicketingApiWiring } from "@/lib/ticketingApiProvider";
import { getTicketingApi, type TicketQuote } from "@/lib/ticketingApi";

const QUOTE_REFRESH_MS = 30_000;
export type HomepagePromoQuote = TicketQuote;

/** Shared cached quote from the same ticketing adapter used by ticket purchase. */
export function useHomepagePromoQuote(slug: string, enabled = true) {
  useTicketingApiWiring();
  const query = useQuery({
    queryKey: ["homepage-ticket-quote", slug],
    queryFn: () => getTicketingApi().ticketQuote({ slug }),
    enabled: Boolean(slug) && enabled,
    retry: false,
    staleTime: QUOTE_REFRESH_MS,
    refetchInterval: query => {
      if (typeof document === "undefined" || document.visibilityState !== "visible") return false;
      const quote = query.state.data;
      if (query.state.status === "error" || !quote?.nextPriceChangeAt || !quote.serverNow) return QUOTE_REFRESH_MS;
      const remaining = Date.parse(quote.nextPriceChangeAt) - Date.parse(quote.serverNow)
        - (Date.now() - query.state.dataUpdatedAt);
      return Number.isFinite(remaining) ? Math.min(QUOTE_REFRESH_MS, Math.max(250, remaining + 25)) : QUOTE_REFRESH_MS;
    },
    refetchOnWindowFocus: true,
  });
  return { quote: query.isError ? null : query.data ?? null, failed: query.isError };
}
